"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function OurPreservationPhilosophy() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="our-preservation-philosophy" ref={sectionRef} className="w-full bg-background overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[700px]">
        {}
        <div className={cn("relative h-[400px] lg:h-auto w-full overflow-hidden transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10")}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1570251/img/craftsman_inspecting_stone_joint.png" alt="Craftsman inspecting a stone joint with precision" className="absolute inset-0 h-full w-full object-cover object-center" />
          {}
          <div className="absolute inset-0 bg-black/10" />
        </div>

        {}
        <div className={cn("flex flex-col justify-center px-8 py-16 lg:px-20 lg:py-24 bg-muted transition-all duration-1000 ease-out delay-300", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
          <div className="max-w-xl mx-auto lg:mx-0">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground tracking-tight mb-8 leading-tight">
              Beyond Sealing: <br />
              <span className="text-primary">We Preserve Legacies.</span>
            </h2>

            <div className="space-y-6 text-muted-foreground text-lg leading-relaxed">
              <p>
                At Island Seals, we view every surface as a testament to durability and design. 
                Our philosophy goes beyond simple application; we engineer longevity into every 
                square inch of concrete and stone we touch.
              </p>
              <p>
                By combining technical precision with advanced, environmentally responsible 
                sealants, we ensure your investments withstand the harshest elements. 
                We don't just protect surfaces—we safeguard the structural integrity and 
                aesthetic beauty that defines your space.
              </p>
            </div>

            <div className="mt-12 pt-8 border-t border-border/50">
              <p className="text-sm font-medium text-foreground uppercase tracking-widest mb-4">
                Founder's Promise
              </p>
              <div className="font-serif italic text-3xl text-primary opacity-90">Justin Rancourt</div>
              <p className="text-sm text-muted-foreground mt-1">
                Lead Sealant Specialist, Island Seals
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}